export default class effectManager {
    constructor(){

        this.svg1;
        this.svg2;
        this.svg3;
        this.status = {
            start : false,
            play : false
        }

    }
    moveX($target,type){
        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
                x:-100
            });
        }else{
            TweenMax.to($target,0.8, {
                x:0,
                opacity:1,
                ease: Sine.easeOut,
            });
        }

    }

    moveY($target,type){
        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
                y:50
            });
        }else{
            TweenMax.staggerTo($target,0.6, {
                y:0,
                opacity:1,
                ease: Back.easeOut.config(1)
            },0.06);
            TweenMax.staggerTo($target,.8, {
                scale:1,
                ease: Sine.easeOut,
                transformOrigin:"50% 50%"
            },0.06);
        }

    }

    moveMain($target,type){
        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
                z:-15,
                y:50,
                rotation:-3,
                scale:0.8,
            });
        }else{
            TweenMax.staggerTo($target,1, {
                delay:0.2,
                z:0,
                y:0,
                opacity:1,
                rotation:0,
                scale:1,
                ease: Back.easeOut.config(1)
            },0.1);
        }

    }

    Scale($target,type){
        if(type==="set"){
            TweenMax.set($target,{
                opacity:0,
                y:50,
                rotation:-5,
                scale:0.6,
            });
        }else{
            TweenMax.staggerTo($target,1, {
                y:0,
                opacity:1,
                rotation:0,
                scale:1,
                ease: Back.easeOut.config(1)
            },0.1);
        }

    }

    Title($target,type){

        if(type === "set"){
            for(let i=0; $target.length>i; i++) {
                let text = new SplitText($target[i].firstElementChild, {type: "words,chars"}),
                    chars = text.chars;
                TweenMax.set(chars, {opacity: 0, y: '80%'});
                TweenMax.set($target[i].lastElementChild, {opacity: 0, y: 30});
            }
        }else{
            if($target.length === 0) return;
            TweenMax.staggerTo($target[0].querySelectorAll(".en>*>*"), 0.8,
                {
                    y:'0%',
                    opacity:1,
                    ease: Back.easeOut.config(1)
                }, 0.02
            );
            TweenMax.to($target[0].querySelectorAll(".jp"), 0.6,
                {
                    y:0,
                    opacity:1,
                    ease: Sine.easeOut,
                }
            );
        }
    }

    Btn($target,type){

        if(type === "set"){
            for(let i=0; $target.length>i; i++) {
                let jp = new SplitText($target[i].querySelector(".jp"), {type: "words,chars"}),
                    chars1 = jp.chars;
                let en = new SplitText($target[i].querySelector(".en"), {type: "words,chars"}),
                    chars2 = en.chars;
                TweenMax.set(chars2, {opacity: 0, y: '5px'});
            }
        }else if(type === "on"){
            TweenMax.set($target, {className:"+=type-hover"});
            TweenMax.staggerTo($target.querySelectorAll(".jp>*>*"), 0.3,
                {
                    y:'-5px',
                    opacity:0,
                    ease: Power2.easeOut,
                }, 0.01
            );
            TweenMax.staggerTo($target.querySelectorAll(".en>*>*"), 0.3,
                {
                    y:'0px',
                    opacity:1,
                    ease: Power2.easeIn,
                }, 0.01
            );
        }else{
            TweenMax.set($target, {className:"-=type-hover"});
            TweenMax.staggerTo($target.querySelectorAll(".jp>*>*"), 0.3,
                {
                    y:'0px',
                    opacity:1,
                    ease: Power2.easeIn,
                }, 0.01
            );
            TweenMax.staggerTo($target.querySelectorAll(".en>*>*"), 0.3,
                {
                    y:'5px',
                    opacity:0,
                    ease: Power2.easeOut,
                }, 0.01
            );
        }
    }

    flow($target,type){
        if(type==="set"){
            TweenMax.set($target,{
                x:-50,
                z:-5,
                y:-5,
                opacity: 0,
            });
        }else{
            TweenMax.staggerTo($target,0.6, {
                x:0,
                z:0,
                y:0,
                opacity: 1,
                ease : Back.easeOut.config(1),
            },0.15);
        }

    }

    contactIllust(type){

        let _illsut = document.querySelectorAll(".js__pigeon");
        let _illsutLast = document.querySelector(".js__pigeon-last");

        if(type==="set"){
            for(let i=0; _illsut.length>i; i++) {
                TweenMax.set(_illsut[i], {
                    opacity: 0,
                    cycle:{
                        x: [-5, 15],
                    },
                    y: '-10px',
                    z:-5,
                });
            }
            TweenMax.set(_illsutLast, {
                opacity: 0,
                x: '10px',
                y: '-10px',
                z:-5,
            });
        }else{

            //let tl = new TimelineMax({repeat:-1, repeatDelay:.9});
            let tl = new TimelineMax();

            tl.staggerTo(_illsut,0.8, {
                x:0,
                y:0,
                z:0,
                opacity:1,
                ease: Sine.easeOut
            },0.2).to(_illsutLast,.8, {
                x: 0,
                y: 0,
                z: 0,
                opacity: 1,
                ease: Sine.easeOut
            });
            // }).staggerTo(_illsut,0.8, {
            //     delay:1.1,
            //     opacity: 0,
            //     cycle:{
            //         x: [-5, 15],
            //     },
            //     y: '-10px',
            //     z:-5,
            //     ease: Sine.easeOut,
            //     onStart:function(){
            //         TweenMax.to(_illsutLast,.8, {
            //             opacity: 0,
            //             x: '10px',
            //             y: '-10px',
            //             z:-5,
            //             ease: Sine.easeOut
            //         });
            //     }
            // },0.2);
        }

    }

    svgMorph(type,target){

        let _morph1 = 'M317,149.5c0,28.1-10.3,53-24.2,75.6c-14.1,22.9-33,41.3-57.1,54.4c-23,12.5-48.4,19.9-76.7,19.9c-32.5,0-58.7-5-80.4-14.8c-27.5-12.5-45.4-31.8-57.8-55.7C8.6,205.4,0,179,0,149.5c0-28.6,12.6-54,28.7-76.9c15.8-22.3,35.9-42.1,61.3-55C114.6,5.2,142.2,0,170.5,0c28.3,0,54.9,3,76.2,15.6c22.8,13.4,42.4,33.5,54.7,56.9C313.2,94.8,317,121.9,317,149.5z';

        let _morph1_end = 'M198.8,308c-26.9,8-53.7,5.3-79.3-1.6c-25.9-7-49-19.8-68.4-39.2c-18.5-18.4-32.9-40.7-41-67.8c-9.3-31.1-12-57.7-8.8-81.3c4.1-30,17.5-52.6,36.8-71.3c18.9-18.3,41.7-34.1,70-42.5C135.6-4,163.5,0.8,190,9.7c25.9,8.7,50.6,22.4,70.2,43c19,20,31.9,45,39.9,72.1c8.1,27.2,12.8,53.4,6.9,77.5c-6.3,25.7-20,50.2-38.9,68.7C250.1,288.6,225.2,300.1,198.8,308z';

        let _morph2 = 'M112.37,5.61c34.56-7.334,66.5-8.585,93.75,3s51.25,34.665,65.25,58s38.38,87.085,35.44,124.335c-2.94,37.25-7.69,68.329-34.44,91.665c-26.75,23.335-55,42.414-103,45c-48,2.585-80.983-21.708-105.867-49.062C38.62,251.195,4.662,197.522,1.141,157.108C-2.38,116.695,0.914,80.81,30.268,52.502C59.62,24.195,95.603,9.168,112.37,5.61z';

        let _morph2_end = 'M216.6,12.3c31.2,15.5,54.8,35.6,68.8,61.2c14,25.6,26.3,58.8,22.8,85.5c-1.8,14-11,37.9-21.1,61.4c-9.3,21.4-22.7,41.1-34.7,54c-25.1,27-46.5,52.1-81.4,53.9c-18.8,0.9-37.9-0.4-56.9-5.1c-16.3-4-32.6-13.3-50.5-25.9c-18.2-12.8-34.8-27.7-45.1-45.1c-11.6-19.6-16.6-42-17.9-61.3c-1.3-18.5-0.5-38.8,3.2-58.5c3.6-19.1,9.8-38.4,20.5-54.8c10.8-16.4,25.5-34.8,42.1-49.7c17.1-15.4,37.4-24.7,57.7-26.8C164.1-2.9,201.4,4.9,216.6,12.3z';

        let _morph3 = 'M10.216,193.953c13.662,26.389,39.484,61.992,75.662,77.457s74.489,20.535,119,17s75.489-26.132,92-52c16.511-25.869,19.619-80.798,12.31-109.898c-7.31-29.102-21.128-80.332-79.297-106.984C171.722-7.125,109.722-2.125,79.722,8.875S18.056,53.208,7.389,88.208S-2.446,169.496,10.216,193.953z';

        let _morph3_end = 'M314,119.7c-1.5-17.7-6.6-35.4-16-51.5c-9.9-17.1-22.7-30.7-36.7-39.4C245.9,19.1,221.1,7,189.9,2.9c-23.4-3.1-50.2-4.9-77,1.1C86.6,9.9,66.8,23.2,52,37C31.9,55.8,20.4,78.4,12.8,94c-6.6,13.5-9.2,34.4-11.6,54.9c-2.4,20.6-1.3,40.3,4.1,54.7c5.9,15.7,15.1,30.8,30.2,43.8c12.6,10.8,28.1,18.7,47.5,24.5c20.7,6.1,39.4,14.6,58.6,16.1c20.5,1.6,40.9-0.2,60.9-4.1c18.3-3.6,36.5-11.2,51.3-21.6c16.4-11.6,28.5-27.9,38.4-40C309.6,200.9,317.2,156.1,314,119.7z';

        if(type === "show"){

            let _this = this;

            TweenMax.to(target, 0.8, {
                opacity:1,
                scale:1,
                transformOrigin:"50% 50%",
                // onComplete:function(){
                //     if(target.id === 'p-top-policy-svg01'){
                //         _this.svg1 = TweenMax.to('#p-top-policy-svg01', 4, {
                //             morphSVG:_morph1_end,
                //             repeat:-1,
                //             yoyo:true
                //         });
                //     }else if(target.id === 'p-top-policy-svg02'){
                //         _this.svg2 = TweenMax.to('#p-top-policy-svg02', 6, {
                //             morphSVG:_morph2_end,
                //             repeat:-1,
                //             yoyo:true
                //         });
                //     }else{
                //         _this.svg3 = TweenMax.to('#p-top-policy-svg03', 5, {
                //             morphSVG:_morph3_end,
                //             repeat:-1,
                //             yoyo:true,
                //         });
                //         _this.status.start = true;
                //         _this.status.play = true;
                //     }
                // }
            });


        }else if(type === "play"){
            if(!this.status.start || this.status.play) return;
            this.status.play = true;
            this.svg1.play();
            this.svg2.play();
            this.svg3.play();
        }else if(type === "pause"){
            if(!this.status.start || !this.status.play) return;
            this.status.play = false;
            this.svg1.pause();
            this.svg2.pause();
            this.svg3.pause();
        }
    }

    lowlayer(){

        let _this  = this;

        let _kv = document.getElementById('p-kv');
        let _en = _kv.querySelector('.en');
        let _jp = _kv.querySelector('.jp');
        let _bg = document.getElementById('p-kv-bg');
        let _bgInner = document.getElementById('p-kv-bg__inner');
        let _body = document.getElementById('p-lowlayer-body');

        let en = new SplitText(_en, {type: "words,chars"}),
            charsEn = en.chars;
        let jp = new SplitText(_jp, {type: "words,chars"}),
            charsJp = jp.chars;

        TweenMax.set(_kv, {
            opacity:1,
        });
        TweenMax.set([_en.children,_jp.children], {
            opacity:0,
        });
        TweenMax.set(_en, {
            rotation:3,
            transformOrigin: "50% 50%",
        });
        TweenMax.set(_en.children, {
            rotation:1,
            y:-5,
            z:-15,
            transformOrigin: "-100% 0%",
        });
        TweenMax.set([_jp,_jp.children], {
            rotation:15,
            y:-30,
            z:-20,
            transformOrigin: "-100% 0%",
        });

        for(let i=0; charsEn.length>i; i++) {
            TweenMax.set(charsEn[i], {
                y:this.getRandom(30, 110)+'%'
            });
        }
        for(let i=0; charsJp.length>i; i++) {
            TweenMax.set(charsJp[i], {
                y:this.getRandom(30, 180)+'%'
            });
        }

        TweenMax.set(_body, { y:'3%', opacity:0 });

        TweenMax.fromTo(_bg, .55, {
            delay:.3,
            y:'50%',
            opacity:0,
        },{
            delay:0.8,
            y:'0%',
            opacity:1,
            ease: Power1.easeOut
        });
        TweenMax.fromTo(_bgInner, .55, {
            y:'70%',
        }, {
            delay: 1.3,
            y: '0%',
            opacity: 1,
            ease: Power1.easeOut,
            onComplete:function(){
                TweenMax.to([_en.children,_jp.children], 0.2 ,{
                    opacity:1,
                    ease: Sine.easeOut,
                });
                TweenMax.to([_en,_jp], 0.3 ,{
                    rotation:0,
                    y:0,
                    z:0,
                    transformOrigin: "0% 0%",
                    ease: Sine.easeOut,
                });
                TweenMax.to([_en.children,_jp.children], 0.5 ,{
                    rotation:0,
                    y:0,
                    z:0,
                    transformOrigin: "0% 0%",
                    ease: Sine.easeOut,
                });
                TweenMax.staggerTo(charsEn, .8,
                    {
                        y:'0%',
                        ease: Back.easeOut.config(1),
                    },0.03);
                TweenMax.staggerTo(charsJp, .8,
                    {
                        y:'0%',
                        ease: Back.easeOut.config(1),
                    },0.03,function(){
                        TweenMax.to(_body, .6, {
                            y:'0%',
                            opacity:1,
                            ease: Sine.easeOut,
                            onComplete:function(){
                                if(document.querySelector(".js__tsc-title-lowlayer")){
                                    let _Title = document.querySelectorAll(".js__tsc-title-lowlayer");
                                    if(_Title) _this.Title(_Title,"show");
                                }
                                if(document.querySelector(".js__tsc-y-lowlayer")){
                                    let _y = document.querySelectorAll(".js__tsc-y-lowlayer");
                                    if(_y) _this.moveY(_y,"show");
                                }
                            }
                        });
                    });
            }
        });

    }

    getRandom(max, min){
        return Math.floor(Math.random() * (1 + max - min) + min);
    }

}
